import { render, staticRenderFns } from "./BCYtable.vue?vue&type=template&id=30cb1a94&scoped=true"
import script from "./BCYtable.vue?vue&type=script&lang=js"
export * from "./BCYtable.vue?vue&type=script&lang=js"
import style0 from "./BCYtable.vue?vue&type=style&index=0&id=30cb1a94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb1a94",
  null
  
)

export default component.exports